import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';

function EscalationReportDetailModal({ }, ref) {

    const modalId = uuid();
    const modalElementRef = useRef();
    const modalRef = useRef();

    const access_token = useSelector(state => state.auth.access_token);

    const detailUrl = IAM_API_BASE_URL_2 + '/escalation_user_site_wise';
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState([]);
    const [siteName, setSitename] = useState("");


    useImperativeHandle(ref, () => ({
        initModalHandler: (site) => {
            openModal();
            if (site?.site_id) {
                setSitename(site)
                detailData(site?.site_id);
            }
        }
    }));

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, { keyboard: false, backdrop: false });
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const detailData = (id) => {
        setLoading(true);
        HttpAPICall.withAthorization("GET", `${detailUrl}/${id}`, access_token, {}, {}, (resp) => {
            let data = resp.data;
            setDetail(data);
        }).then(() => {
            setLoading(false);
        })
    }

    const openModal = () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }

    const closeModal = () => {
        modalRef.current.hide();
    }

    return (
        <>
            <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Escalation Detail</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {loading ? <Loader /> :
                                <>
                                    <table className="table table-hover table-borderless bg-white">
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "25%" }}>Site Name :</td>
                                                <th>{siteName?.site_name}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {detail.length > 0 ? (
                                        detail.map((level, index) => (
                                            <div key={level.id} className="">
                                                <h6 className="mb-0">
                                                    {level.name}
                                                </h6>

                                                <table className="table table-hover  table-bordered mt-2">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-center" style={{ width: "5%" }}>#</th>
                                                            <th style={{ width: "25%" }}>Name</th>
                                                            <th style={{ width: "35%" }}>Email</th>
                                                            <th style={{ width: "35%" }}>Mobile</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {level.users && level.users.length > 0 ? (
                                                            level.users.map((user, userIndex) => (
                                                                <tr key={user.id}>
                                                                    <td className="text-center">{userIndex + 1}</td>
                                                                    <td>
                                                                        {user.first_name} {user.last_name}
                                                                    </td>
                                                                    <td>
                                                                        {user.email}
                                                                    </td>
                                                                    <td>
                                                                        {user.mobile}
                                                                    </td>
                                                                </tr>
                                                            ))) :
                                                            <tr>
                                                                <td colSpan={4} className=" text-center ">
                                                                    No users assigned to this level
                                                                </td>
                                                            </tr>}
                                                    </tbody>
                                                </table>

                                            </div>
                                        ))
                                    ) : <div className=" text-center py-3">
                                        No Records Found
                                    </div>}
                                </>
                            }
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default forwardRef(EscalationReportDetailModal)